export default angular.module('ApiUtils.khutils', [
    'ApiUtils.khutils.teams',
    'ApiUtils.khutils.seasons',
    'ApiUtils.khutils.ui'
]);